import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './recordController.json';

const MP_RECORD_SIMULATED_DELAY_MS = 3000;

const queryInvoiceRecordData = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['recordController/queryInvoiceRecordData'].success.default)));
};

const queryPayRecordData = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['recordController/queryPayRecordData'].success.default)));
};

const queryRecordPageData = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['recordController/queryRecordPageData'].success.default)));
};

const queryMpRecordData = async (req, res, ctx) => {
  await new Promise((resolve) => setTimeout(resolve, MP_RECORD_SIMULATED_DELAY_MS));
  return res(ctx.json(mockResponse(apiResponses['recordController/queryMpRecordData'].success.default)));
};

const payRecordPrint = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['recordController/payRecordPrint'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('recordController/queryInvoiceRecordData'),
    withScenario(withAuthCheck(queryInvoiceRecordData))
  ),
  rest.post(getApiEndpoint('recordController/queryPayRecordData'), withScenario(withAuthCheck(queryPayRecordData))),
  rest.post(getApiEndpoint('recordController/queryRecordPageData'), withScenario(withAuthCheck(queryRecordPageData))),
  rest.post(getApiEndpoint('recordController/queryMpRecordData'), withScenario(withAuthCheck(queryMpRecordData))),
  rest.post(getApiEndpoint('recordController/payRecordPrint'), withScenario(withAuthCheck(payRecordPrint))),
];
